import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_e26bd618-434d-4121-947e-65674a4d52da/artifacts/twhikqt6_padel%20logo%20png%202.png";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { username, password });
      localStorage.setItem("admin_token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="w-full max-w-sm fade-in">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="PCDR" className="h-20 mx-auto mb-4" data-testid="admin-logo" />
          <h1 className="text-2xl font-bold text-zinc-950">Panel de Administrador</h1>
        </div>
        <Card className="border border-zinc-200 shadow-none">
          <CardHeader className="pb-4">
            <CardTitle className="flex items-center gap-2 text-lg">
              <Lock className="w-4 h-4" /> Iniciar Sesión
            </CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleLogin} className="space-y-4">
              <div>
                <label className="text-sm font-medium text-zinc-700 mb-1 block">Usuario</label>
                <Input
                  data-testid="admin-username-input"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="admin"
                  required
                  className="border-zinc-300 focus:ring-2 focus:ring-zinc-950"
                />
              </div>
              <div>
                <label className="text-sm font-medium text-zinc-700 mb-1 block">Contraseña</label>
                <Input
                  data-testid="admin-password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  className="border-zinc-300 focus:ring-2 focus:ring-zinc-950"
                />
              </div>
              {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-zinc-950 text-white hover:bg-zinc-800"
                data-testid="admin-login-btn"
              >
                {loading ? "Ingresando..." : "Ingresar"}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
